import Layout from "@/components/shared/Layout";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Head from 'next/head'
import { META_IMAGE, SITE_URL } from "@/utils/meta";
import BlogsCards from '@/components/blogs/BlogsCards'
import WhatsappButton from '@/components/shared/WhatsappButton'

export async function getServerSideProps({ locale, query }) {
  const lang = query.lang || locale || "az";
  let blogs = [];
  try {
    const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/blog/posts/?lang=${lang}`, {
      headers: { "ngrok-skip-browser-warning": "true" },
    });
    if (res.ok) {
      blogs = await res.json();
    }
  } catch (err) {
    // console.error("Failed to fetch blogs:", err);
  }
  return {
    props: {
      ...(await serverSideTranslations(lang)),
      blogs,
    },
  };
}

const Blogs = ({ blogs }) => {
  const { t, i18n } = useTranslation();
  const pageUrl = `${SITE_URL}${i18n.language === "az" ? "" : `/${i18n.language}`}/blogs`;
  return (
    <Layout>
      <Head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{t("blogs.meta-title")}</title>
        <meta name="description" content={t("blogs.meta-description")} />
        <meta name="image" content={META_IMAGE} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:site_name" content="peerstack.tech" />
        <meta property="og:title" content={t("blogs.meta-title")} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:description" content={t("blogs.meta-description")} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={META_IMAGE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t("blogs.meta-title")} />
        <meta name="twitter:url" content={pageUrl} />
        <meta name="twitter:description" content={t("blogs.meta-description")} />
        <meta name="twitter:image" content={META_IMAGE} />
        {/*<script*/}
        {/*  type="application/ld+json"*/}
        {/*  dangerouslySetInnerHTML={{*/}
        {/*    __html: JSON.stringify({*/}
        {/*      "@context": "https://schema.org",*/}
        {/*      "@type": "Organization",*/}
        {/*      name: "PeerStack",*/}
        {/*      alternateName: "PeerStack Tech",*/}
        {/*      url: "https://peerstack.tech",*/}
        {/*      logo: Logo.src,*/}
        {/*      contactPoint: {*/}
        {/*        "@type": "ContactPoint",*/}
        {/*        telephone: "50 999 88 77",*/}
        {/*        contactType: "customer service",*/}
        {/*        areaServed: "AZ",*/}
        {/*        availableLanguage: "Azerbaijani",*/}
        {/*      },*/}
        {/*      sameAs: ["https://peerstack.tech/", "https://peerstack.tech/"],*/}
        {/*    }),*/}
        {/*  }}*/}
        {/*/>*/}
      </Head>
      <BlogsCards blogs={blogs} />
      <WhatsappButton />
    </Layout>
  );
};

export default Blogs;